"use client";

import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Strategy() {
  const filters = [{
    label: "ALL",
    key: "all"
  }, {
    label: "INDIVIDUALS",
    key: "individuals"
  }, {
    label: "BUSINESSES",
    key: "businesses"
  }, {
    label: "COMPLIANCE",
    key: "compliance"
  }, {
    label: "ADVISORY",
    key: "advisory"
  }];
  const [activeFilter, setActiveFilter] = useState("all");
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.15
  });
  return <section data-section-id="1982" id="lets-discuss-your-strategy" className="dark relative overflow-hidden bg-background py-28 md:py-36 border-b border-border">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-end justify-center select-none">
        <span className="font-default font-normal leading-none tracking-tight text-foreground/[0.06] translate-y-8 md:translate-y-12" style={{
        fontSize: "clamp(8rem, 18vw, 14rem)"
      }}>
          TAX.24
        </span>
      </div>

      <div className="relative mx-auto px-6 md:px-10 lg:px-16" style={{
      maxWidth: "880px"
    }}>
        <div ref={ref} className={`flex flex-col items-center text-center transition-opacity duration-700 ease-out ${isVisible ? "opacity-100" : "opacity-0"}`}>
          {}
          <div className="font-mono text-[12px] font-medium uppercase text-foreground" style={{
          letterSpacing: "0.16em"
        }}>
            § — Lovejoy Company
          </div>

          {}
          <h1 className="mt-8 font-default font-normal text-foreground" style={{
          fontSize: "clamp(2.5rem, 5.4vw, 4.75rem)",
          letterSpacing: "-0.022em",
          lineHeight: "1.02"
        }}>
            Compliance, planning, and <em className="italic">financial clarity</em>.
          </h1>

          {}
          <div className="mt-10 flex items-center" style={{
          width: "240px"
        }} aria-hidden="true">
            <span className="h-px flex-1 bg-border" />
            <span className="ml-0 inline-block h-1.5 w-1.5 rounded-lg bg-accent" />
          </div>

          {}
          <p className="mt-10 font-default italic text-muted-foreground" style={{
          fontSize: "18px",
          maxWidth: "560px",
          lineHeight: "1.55"
        }}>
            A professional approach to tax services for individuals and businesses. 
            We provide strategic guidance to ensure compliance and long-term stability.
          </p>

          {}
          <div className="mt-12 -mx-6 md:mx-0 w-screen md:w-auto">
            <div className="flex flex-nowrap md:flex-wrap items-center justify-start md:justify-center gap-2 overflow-x-auto px-6 md:px-0 md:overflow-visible pb-2 md:pb-0">
              {filters.map((filter, i) => {
              const isActive = activeFilter === filter.key;
              return <Button key={filter.key} data-index={i} type="button" variant="outline" onClick={() => setActiveFilter(filter.key)} aria-pressed={isActive} className={`h-auto shrink-0 rounded-lg border px-4 py-2.5 font-mono text-[11px] font-medium uppercase shadow-none transition-colors duration-200 ease-out ${isActive ? "border-accent bg-accent text-background hover:bg-accent hover:text-background" : "border-border bg-transparent text-foreground hover:bg-accent hover:text-background"}`} style={{
                letterSpacing: "0.12em"
              }}>
                    {filter.label}
                  </Button>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
}